import { parseAsPageNumber } from '@shared/utils';
import {
  parseAsArrayOf,
  parseAsIsoDateTime,
  parseAsString,
  parseAsInteger,
  useQueryStates,
} from 'nuqs';

interface FilterParams {
  examCenters: string[] | null;
  startDate: Date | null;
  endDate: Date | null;
  questionnaireTemplate: string | null;
  examCourses: string[] | null;
}

export function useQuestionnaireExportSearchParams() {
  const [
    { examCenters, startDate, endDate, questionnaireTemplate, examCourses, page, pageSize },
    setQuestionnaireExportSearchParams,
  ] = useQueryStates({
    examCenters: parseAsArrayOf(parseAsString).withDefault([]),
    startDate: parseAsIsoDateTime,
    endDate: parseAsIsoDateTime,
    questionnaireTemplate: parseAsString,
    examCourses: parseAsArrayOf(parseAsString).withDefault([]),
    page: parseAsPageNumber,
    pageSize: parseAsInteger.withDefault(10),
  });

  const changeFilter = (params: Partial<FilterParams>) => {
    setQuestionnaireExportSearchParams({ ...params, page: 0 });
  };

  const resetAllParams = () => {
    setQuestionnaireExportSearchParams({
      examCenters: null,
      startDate: null,
      endDate: null,
      questionnaireTemplate: null,
      examCourses: null,
      page: null,
      pageSize: null,
    });
  };

  const changePageNumber = (newPage: number) => {
    setQuestionnaireExportSearchParams({ page: newPage });
  };

  const changePageSize = (newSize: number) => {
    setQuestionnaireExportSearchParams({ pageSize: newSize, page: 0 });
  };

  return [
    {
      examCenters,
      startDate,
      endDate,
      questionnaireTemplate,
      examCourses,
      page: page ?? 0,
      pageSize,
    },
    {
      changeFilter,
      resetAllParams,
      changePageNumber,
      changePageSize,
    },
  ] as const;
}
